import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { APP_SETTINGS } from '@services';
import { Subscription } from 'rxjs';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { SearchResultsService } from '../search-results.service';
import { NgIf, NgClass, NgFor, NgStyle } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-results-side-bar',
    templateUrl: './search-results-side-bar.component.html',
    styleUrls: ['./search-results-side-bar.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        RouterLink,
        NgClass,
        FormsModule,
        NgFor,
        NgStyle,
    ],
})
export class SearchResultsSideBarComponent implements OnInit, OnDestroy {
  public section: string;
  public search_key: string;
  public subscription: Subscription[] = [];
  public screenWidth: number;
  // private results_count_arr: any[] = [];

  @ViewChild('selectMainGroup')
  private elSelectMainGroup: ElementRef;
  @ViewChild('selectFromYr')
  private elSelectFromYr: ElementRef;
  APP_SETTINGS: any;
  public noMainGroupError = '';
  public noFromYear = '';
  public noToYear = '';
  public fromYears: number[] = [];
  public toYears: number[] = [];
  private currentYear: number;

  public selectGroup = '';
  public selectBody = '';
  public selectFromYear = '';
  public selectToYear = '';
  public selectSeries = '';

  private filterCriteria = { group: '', series: '', body: '', from: '', to: '' };

  public mainGroupList: string[];
  public bodyTypeList: any[];
  public isExternal: boolean; //ASENGG-29592 Technical Documentation solr search fix for external users
  // bulletinLabel addedd for is Motorrad --Vishal
  bulletinLabel = 'TRI Bulletins';
  userRoles = {};


  // emit event to pass data to parent
  // @Output() resultCount = new EventEmitter<any[]>();
  constructor(private route: ActivatedRoute, private router: Router,
    private utilityService: UtilityService, private changeDetector: ChangeDetectorRef,
    private searchResultsService: SearchResultsService) {
    this.section = this.route.snapshot.paramMap.get('section');
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
   //ASENGG-29592 Technical Documentation solr search fix for external users
   this.APP_SETTINGS = APP_SETTINGS;
   this.isExternal = this.APP_SETTINGS['isExternal'];

    this.userRoles = JSON.parse(localStorage.getItem('USER_INFO'));
    APP_SETTINGS.isMOTORRAD = this.userRoles['isMotorrad'];
    this.APP_SETTINGS = APP_SETTINGS;

    this.currentYear = (new Date()).getFullYear();
    for (let year: number = 1985; year < this.currentYear + 1; year++) {
      this.fromYears.push(year);
      this.toYears.push(year);
    }
    if (APP_SETTINGS.isMOTORRAD === "true") {
      this.mainGroupList = APP_SETTINGS.motorradMainGroupList;
      this.bulletinLabel = 'Authority Bulletins';
    }
    else {
    this.mainGroupList = APP_SETTINGS.mainGroupList;
    }

    this.bodyTypeList = this.initializeBodyTypes();

    this.subscription.push(this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const value = this.route.snapshot.paramMap.get('section');
        this.section = value;
      }
    }));

    this.subscription.push(this.utilityService.emit_dropdown$.subscribe(value => {
      this.section = value.toLowerCase();
      this.clearFilter();
      this.changeDetector.detectChanges();
    }));
    // this.subscription.push(this.utilityService.emit_results_count.subscribe(value => this.results_count_arr = value));

  }
  sendSelectedSectionToHeader(section: string): void {
    this.utilityService.changeDropdown(section);
  }

  initializeBodyTypes() {
    return [
      { id: 0, name: 'Compact' },
      { id: 1, name: 'Convertible' },
      { id: 2, name: 'GT' },
      { id: 3, name: 'HatchBack' },
      { id: 4, name: 'SAV' },
      { id: 5, name: 'Sedan' },
      { id: 6, name: 'Sports Wagon' },
      { id: 7, name: 'Touring' },
      { id: 8, name: 'Wagon' },
      { id: 9, name: 'Coupe' },
      { id: 10, name: 'Roadster' }
    ];
  }

  // changeMainGroup() {
  //   // this.selectGroup = this.selectGroup.length > 24 ?
  //   //                     this.selectGroup.substr(0, 21) + '...' : this.selectGroup;
  //   this.utilityService.publishMainGroup(this.selectGroup);
  // }
  changeSeriesInput() {
    if (this.selectSeries.trim() !== '') {
      this.searchResultsService.getSeriesToBody().subscribe(data => {
        const userSelectedSeries = data.find(item => item.seriesName === this.selectSeries.trim().toUpperCase());
        this.bodyTypeList = userSelectedSeries.bodies;
        this.changeDetector.detectChanges();
      });
    } else {
      this.bodyTypeList = this.initializeBodyTypes();
    }
  }

  clearFilter() {
    this.selectGroup = '';
    this.selectSeries = '';
    this.selectBody = '';
    this.selectFromYear = '';
    this.selectToYear = '';
    this.noMainGroupError = this.noFromYear = this.noToYear = '';
    this.filterCriteria = {
      group: '',
      series: '',
      body: '',
      from: '',
      to: ''
    };
    this.utilityService.publishFilterCriteria(this.filterCriteria);
    this.changeDetector.detectChanges();
  }
  applyFilter() {
    // apply filter only if user selects a main group
    let mainGroupCode = '';
    if (this.elSelectMainGroup.nativeElement.disabled) {
      if (this.selectFromYear || this.selectToYear) {
        if (!this.selectFromYear) {
          this.noFromYear = 'Please select the year';
        } else if (!this.selectToYear) {
          this.noToYear = 'Please select the year';
        } else {
          this.filterCriteria = {
            group: mainGroupCode,
            series: this.selectSeries.trim(),
            body: this.selectBody,
            from: this.selectFromYear,
            to: this.selectToYear
          };
          this.noFromYear = '';
          this.noToYear = '';
        }
      }
    } else {
      if((this.section !=='all' && this.section !=='sib')) {

        if (this.selectGroup) {
          if (this.selectFromYear || this.selectToYear) {
            if (!this.selectFromYear) {
              this.noFromYear = 'Please select the year';
            } else if (!this.selectToYear) {
              this.noToYear = 'Please select the year';
            } else {
              this.noFromYear = '';
              this.noToYear = '';
            }

          }
          const matchString = this.selectGroup.match(/\[(.*?)\]/)[1];
          mainGroupCode = +matchString < 10 ? '0' + matchString : matchString;
          this.filterCriteria = {
            group: mainGroupCode,
            series: this.selectSeries.trim(),
            body: this.selectBody,
            from: this.selectFromYear,
            to: this.selectToYear
          };
          this.noMainGroupError = '';
        } else {
          this.noMainGroupError = 'Please select a Main Group to filter results';
        }
      } else {
        if(this.selectGroup.length>0) {
          const matchString = this.selectGroup.match(/\[(.*?)\]/)[1];        
          mainGroupCode = +matchString < 10 ? '0' + matchString : matchString;
          this.filterCriteria = {
            group: mainGroupCode,
            series: this.selectSeries.trim(),
            body: this.selectBody,
            from: this.selectFromYear,
            to: this.selectToYear
          };
        }
        else {
          this.filterCriteria = {
            group: "",
            series: this.selectSeries.trim(),
            body: this.selectBody,
            from: this.selectFromYear,
            to: this.selectToYear
          };
        }
        this.noMainGroupError = '';
      }

    }

    this.changeDetector.detectChanges();
    if (!this.noToYear && !this.noFromYear) {
      this.utilityService.publishFilterCriteria(this.filterCriteria);
    }
  }

  ngOnDestroy(): void {
    this.subscription.forEach(s => s.unsubscribe());
  }
}
